import { render } from "./LegacyRfpDetails.vue?vue&type=template&id=ee54021a&scoped=true"
import script from "./LegacyRfpDetails.vue?vue&type=script&lang=js"
export * from "./LegacyRfpDetails.vue?vue&type=script&lang=js"

import "./LegacyRfpDetails.vue?vue&type=style&index=0&id=ee54021a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee54021a"]])

export default __exports__